import { invoke } from "~/runtime"
import clsx from "~/sdk/clx"
import { useSignal } from "~/sdk/signal"
import type { Product } from "@decocms/apps-commerce/types"
import type { JSX } from "react"

export interface Props {
    productID: Product['productID']
}

function Notify({ productID }: Props) {
    const loading = useSignal(false)
    const subscribed = useSignal(false)

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        try {
            loading.value = true

            const name = (e.currentTarget.elements.namedItem('name') as RadioNodeList)?.value
            const email = (e.currentTarget.elements.namedItem('email') as RadioNodeList)?.value

            await invoke.vtex.actions.notifyme({ skuId: productID, name, email })

            subscribed.value = true
        } catch (err) {
            console.error(err)
            alert('Erro ao cadastrar e-mail')
        } finally {
            loading.value = false
        }
    }

    return (
        <div className={clsx(subscribed.value ? 'my-3' : 'my-5')}>
            {subscribed.value
                ? (
                    // 102% width to fix the text breaking in mobile
                    <p className='text-sm font-bold italic w-[102%]'>
                        Obrigada, avisaremos assim que o produto chegar!
                    </p>
                )
                : (
                    <form
                        // `form-control` (flex column) foi REMOVIDO no DaisyUI 5:
                        // a classe não gera mais nada, o form caía para
                        // `display:block` e o botão OK subia para o lado do input
                        // de e-mail em vez de ficar embaixo, em largura total —
                        // com `gap-2`/`justify-start` virando no-op junto.
                        className='flex flex-col justify-start gap-2 w-full sm:w-[64%]'
                        onSubmit={handleSubmit}
                    >
                        <div>
                            <p className='text-base leading-4'>Produto Esgotado :{'('}</p>
                            <p className='text-base leading-4'>Avise-me quando chegar.</p>
                        </div>
                        <input
                            placeholder='Digite seu nome...'
                            className='input input-bordered text-sm px-2 h-[38px] !outline-0 autofill:text-white autofill:bg-transparent'
                            name='name'
                            required
                            disabled={loading.value}
                        />
                        <input
                            placeholder='Digite seu e-mail...'
                            className='input input-bordered text-sm px-2 h-[38px] !outline-0 autofill:text-white autofill:bg-transparent'
                            name='email'
                            required
                            disabled={loading.value}
                        />
                        <button
                            type='submit'
                            className='btn bg-salmon hover:bg-salmon hover:border-none min-h-0 text-white disabled:mx-auto disabled:loading h-[38px]'
                            disabled={loading.value}
                        >
                            OK
                        </button>
                    </form>
                )}
        </div>
    )
}

export default Notify
